// Token costs per AI action — edit these values freely
export const TOKEN_COSTS = {
  GENERATE_ITINERARY: 10,
  REGENERATE_ITINERARY: 5,
  AI_CHAT_MESSAGE: 2,
  GENERATE_HOTELS: 3,
  GENERATE_INSIGHTS: 3,
  CREATE_ITINERARY_MANUAL: 1,
};

// Subscription plans — placeholder values, wire to Stripe later
export const PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    trialTokens: 20,
    monthlyTokens: 0,
    price: null,
    description: 'Get started with 20 tokens to explore the planner.',
    features: [
      '20 trial tokens',
      'Build and save trips',
      'Access to Atlas Files',
      'Community itineraries',
    ],
  },
  explorer: {
    id: 'explorer',
    name: 'Explorer',
    trialTokens: 0,
    monthlyTokens: 100,
    price: 9,
    currency: '€',
    description: '100 tokens every month. Perfect for regular trip planning.',
    features: [
      '100 tokens per month',
      'Everything in Free',
      'AI hotel suggestions',
      'Trip Insights & Discover',
      'Priority support',
    ],
  },
  atlas_pro: {
    id: 'atlas_pro',
    name: 'Atlas Pro',
    trialTokens: 0,
    monthlyTokens: 9999,
    price: 24,
    currency: '€',
    unlimited: true,
    description: 'Unlimited planning. For frequent travellers and power users.',
    features: [
      'Unlimited tokens',
      'Everything in Explorer',
      'Unlimited AI chat',
      'Advanced trip insights',
      'Early access to new features',
    ],
  },
};

export const STARTER_TOKENS = 20;

export const ACTION_LABELS = {
  GENERATE_ITINERARY: 'Generate itinerary',
  REGENERATE_ITINERARY: 'Regenerate itinerary',
  AI_CHAT_MESSAGE: 'AI chat message',
  GENERATE_HOTELS: 'Hotel suggestions',
  GENERATE_INSIGHTS: 'Trip Insights',
  CREATE_ITINERARY_MANUAL: 'New itinerary',
};
